<template>
  <div class="image-cropper-dailog dialog col-block">
    <cropper
      ref="cropper"
      stencil-component="circle-stencil"
      :src="param.url"
      :imageRestriction="'stencil'"
      :default-size="defaultSize"
      :stencil-size="stencilSize"
      :stencil-props="{
        lines: {},
        handlers: {},
        movable: false,
        scalable: false,
        aspectRatio: 1
      }"
      :canvas="{
        width: 320,
        height: 320
      }"
      :style="{
        'min-width': '160px',
        'min-height': '160px'
      }"
    />
    <div :style="{ height: '20px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="main-button circle-button" @click="e => sendResult()">
        <span>{{ 'Select'/* ___ */ }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import { Cropper, CircleStencil } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
import 'vue-advanced-cropper/dist/theme.classic.css'

export default {
  components: {
    Cropper,
    CircleStencil
  },
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    defaultSize ({ imageSize }) {
      return {
        width: Math.min(imageSize.height, imageSize.width),
        height: Math.min(imageSize.height, imageSize.width)
      }
    },
    stencilSize ({ boundaries }) {
      return {
        width: Math.min(boundaries.height, boundaries.width) * 0.9,
        height: Math.min(boundaries.height, boundaries.width) * 0.9
      }
    },
    sendResult () {
      let { canvas } = this.$refs.cropper.getResult()
      canvas.toBlob(blob => {
        let result = {
          file: blob,
          url: canvas.toDataURL()
        }
        this.$emit('changeModal', {}, result)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/imageCropper.vue